import 'material-design-icons-iconfont/dist/material-design-icons.css';
import Vue from 'vue';
import Vuetify, {
  VDialog,
  VForm
} from 'vuetify/lib';
import pt from 'vuetify/src/locale/pt.ts';

Vue.use(Vuetify, {
  components: {
    VDialog,
    VForm
  }
});

export default new Vuetify({
  fontsize: {
    base: 15
  },
  icons: {
    iconfont: 'md'
  },
  lang: {
    locales: { pt },
    current: 'pt'
  },
  theme: {
    themes: {
      light: {
        primary: '#1a2740',
        secondary: '#333333',
        tertiary: '#ffffff',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#1a2740',
        success: '#9CCC65',
        warning: '#FFC107',
        background: '#f2f2f2',
        bgheader: '#1a2740',
        toolbarBase: '#425e94'
      },
      dark: {
        primary: '#ffffff',
        secondary: '#ffffff',
        tertiary: '#333333',
        accent: '#ffffff',
        error: '#ffffff',
        info: '#ffffff',
        success: '#ffffff',
        warning: '#ffffff',
        background: '#000000',
        bgheader: '#000000'
      }
    }
  }
});
